import React from "react"

const VideoGallery = ({ videos }) => {
  return (
    <div className="gallery_container">
      <div className="video">
        {videos.map(({ link, videoTitle }, i) => (
          <iframe
            key={i}
            src={link}
            title={videoTitle && videoTitle}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen={true}
          />
        ))}
      </div>
    </div>
  )
}

export default VideoGallery
